import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { isPublicPath } from '../../routing/publicRoutes';
import baseServerUrl from '../../services/apiServer';

export const baseApi = createApi({
  reducerPath: 'baseApi',
  baseQuery: async (args, api, extraOptions) => {
    const rawBaseQuery = fetchBaseQuery({
      baseUrl: `${baseServerUrl}/api/v10`,
      credentials: 'include',
    });
    const result = await rawBaseQuery(args, api, extraOptions);
    if (result?.error?.status === 401) {
      const currentPath = window.location.pathname;
      if (!isPublicPath(currentPath)) {
        window.location.replace(`${baseServerUrl}/login`);
      }
    }
    return result;
  },
  tagTypes: ['Contacts', 'User', 'Referral', 'Jobs', 'Organizations', 'Company', 'ReferUsers', 'Candidate', 'Tracker', 'TrackerSearch', 'TrackerDetail', 'InterviewStages'],
  endpoints: () => ({}), // endpoints injected later
});
